<template>
  <button
      class="btn border-radius-19 col-12 my-2"
      @click="close()"
      data-dismiss="modal"
      :disabled="disabled"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "ModalHideButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>
